import * as v from 'valibot';

export const GlossarySchema = v.record(
  v.string(),
  v.record(v.string(), v.string()),
);

export type GlossaryEntries = v.InferOutput<typeof GlossarySchema>;

export function parseGlossary(raw: unknown): GlossaryEntries {
  let candidate: unknown = raw;
  if (typeof raw === 'string') {
    try {
      candidate = JSON.parse(raw);
    } catch {
      return {};
    }
  }
  const result = v.safeParse(GlossarySchema, candidate);
  return result.success ? result.output : {};
}

export function serializeGlossary(value: GlossaryEntries): string {
  const cleaned: GlossaryEntries = {};
  for (const [lang, entries] of Object.entries(value)) {
    const trimmed: Record<string, string> = {};
    for (const [from, to] of Object.entries(entries)) {
      const fromKey = from.trim();
      const toValue = to.trim();
      if (fromKey && toValue) trimmed[fromKey] = toValue;
    }
    if (Object.keys(trimmed).length > 0) cleaned[lang] = trimmed;
  }
  return JSON.stringify(cleaned);
}

export function countGlossaryEntries(value: GlossaryEntries): number {
  return Object.values(value).reduce(
    (total, entries) => total + Object.keys(entries).length,
    0,
  );
}
